export const errorCodes = {
  ERR_UNKNOWN: 'ERR_UNKNOWN',
  ERR_OFFLINE: 'ERR_OFFLINE',
  K0001: 'K0001',
  K0002: 'K0002',
  K0003: 'K0003',
  K0004: 'K0004',
  K0005: 'K0005',
  K0006: 'K0006',
  K0007: 'K0007',
  K1001: 'K1001',
  K1002: 'K1002',
  K1003: 'K1003',
  K1004: 'K1004',
  K1005: 'K1005',
  K1006: 'K1006',
  K2001: 'K2001',
  K3001: 'K3001',
  K3002: 'K3002',
  K3003: 'K3003',
  K4001: 'K4001',
  K4002: 'K4002',
  K4003: 'K4003',
  K4004: 'K4004',
  K4005: 'K4005',
  K4006: 'K4006',
  K4007: 'K4007',
  K4008: 'K4008',
  K4009: 'K4009',
  K4010: 'K4010',
  K4011: 'K4011',
  K4012: 'K4012',
  K4013: 'K4013',
  K4020: 'K4020',
  K5001: 'K5001',
  K5002: 'K5002',
  K5003: 'K5003',
  K5004: 'K5004',
  K6001: 'K6001',
  K7001: 'K7001',
  K7002: 'K7002',
  K7003: 'K7003',
  K7004: 'K7004',
  K7005: 'K7005',
  KP001: 'KP001',
  KP002: 'KP002',
  KP003: 'KP003',
  KP004: 'KP004',
  KP005: 'KP005',
  P0002: 'P0002',
  Q0001: 'Q0001',
  Q0002: 'Q0002',
  Q0006: 'Q0006',
  Q0007: 'Q0007',
  Q0008: 'Q0008',
}
